module.exports = __webpack_public_path__ + "img/traffic_jam.8ddc9568.svg";